// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterBottom_container__LLDWv"};